import { type Editor, Extension } from '@tiptap/core';
import { getExtensionOption } from '../private/utils/getExtensionOption';

export type EnterBehaveStorage = {
  isMultiLine: boolean | undefined;
};

export const enterBehaveExtension = Extension.create<never, EnterBehaveStorage>(
  {
    name: 'enterBehave',
    storage: {
      isMultiLine: undefined,
    },
    addKeyboardShortcuts() {
      return {
        Enter: () => {
          const options = getExtensionOption(this.editor, 'enterBehave');
          if (this.storage.isMultiLine === undefined) {
            return !options.createNewLine;
          }

          return !this.storage.isMultiLine;
        },
        'Shift-Enter': ({ editor }) => {
          if (this.storage.isMultiLine) {
            return false;
          }

          this.storage.isMultiLine = true;

          editor.chain().enter().focus().run();

          return true;
        },
      };
    },
  },
);

export const isEditorInMultiLine = (editor: Editor) => {
  const storage = editor.storage.enterBehave;
  return storage?.isMultiLine ?? false;
};

export const resetEditorMultiLine = (editor: Editor) => {
  editor.storage.enterBehave.isMultiLine = undefined;
};
